module.exports = __webpack_public_path__ + "img/5.815533b.jpg";